import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { type SlackUserConstructor, SlackUser } from './SlackUser'

export const SlackUserConstructorFactory =
  Factory.Sync.makeFactory<SlackUserConstructor>({
    id: Factory.each(() => `U${faker.random.alphaNumeric(10).toUpperCase()}`),
    name: Factory.each(() => faker.internet.userName().toLowerCase()),
    realName: Factory.each(() => faker.name.findName()),
    email: Factory.each(() => faker.internet.email()),
  })

export const SlackUserFactory = EntityFactory(SlackUser, SlackUserConstructorFactory)
